// Vehicle pictures for the Service Desk design. A car's picture comes from the
// brand's vehicle catalog (Super Admin > Vehicles): by the catalog model the
// booking picked, else by matching the typed model name to a catalog name.

const norm = (v) => String(v ?? "").replace(/\s+/g, " ").trim().toLowerCase();

// The catalog row for a group's vehicle, or null. `catalog` is the
// /vehicle-catalog response ({ rows }) or the rows array itself.
export function vehicleImageFor(group, catalog) {
  const rows = Array.isArray(catalog) ? catalog : catalog?.rows || [];
  if (!rows.length || !group) return null;
  const id = Number(group["Vehicle Catalog ID"]);
  const byId = id ? rows.find((r) => Number(r.id) === id) : null;
  if (byId?.thumb_url || byId?.hero_url) return byId;
  const name = norm(group["Vehicle Model"]);
  if (!name) return byId || null;
  return rows.find((r) => norm(r.name) === name && (r.thumb_url || r.hero_url)) || byId || null;
}

// The catalog row for a model name alone (when only the name is known).
export function vehicleImageForName(name, catalog) {
  return vehicleImageFor({ "Vehicle Model": name }, catalog);
}
